import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | ApexPath" />
      <div className="container-x flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
        <span className="font-serif text-7xl font-bold text-gold">404</span>
        <h1 className="mt-4 font-serif text-3xl font-semibold text-navy">Page not found</h1>
        <p className="mt-3 max-w-md text-slate-600">The page you are looking for may have moved or no longer exists.</p>
        <Link to="/" className="btn-gold mt-7">Back to Home</Link>
      </div>
    </>
  );
}
